
<div id="scoreReport" *ngIf="isVisbile">
<!-- page 1 open -->
<div class="SCRPT-page-wrap" >
    <div class="SCRPT-hdr-area">
        <div class="row justify-content-between align-center">
            <div class="col-auto">
                <a><img src="assets/img/learn-white-logo.svg" class="SCRPT-logo" /></a>
            </div>
            <div class="col-auto">
                <img src="assets/img/scorelogo.png" class="SCRPT-strem-logo" />
            </div>
        </div>
    </div>
    <div class="SCRPT-body-area firstpage">

        <div class="SCRPT-wht-border-box SCRPT-main-info-box SCRPT-colview">
            <div class="SCRPT-col">
                <ul class="SCRPT-info-list">
                    <li>
                        <div class="SCRPT-info-hdng-col SCRPT-info-title">Student Name:</div>
                        <div class="SCRPT-info-title"><b>{{(user_details?.firstName +' '+ user_details?.lastName)|titlecase}}</b></div>
                    </li>
                    <li>
                        <div class="SCRPT-info-hdng-col SCRPT-info-title">Student ID:</div>
                        <div class="SCRPT-info-title"><b>{{user_details?.phone}}</b></div>
                    </li>
                    <li>
                        <div class="SCRPT-info-hdng-col SCRPT-info-title">Grade:</div>
                        <div class="SCRPT-info-title"><b>{{selectedTestData?.grade}}</b></div>
                    </li>
                </ul>
            </div>
            <div class="SCRPT-col">
                <ul class="SCRPT-info-list">
                    <li>
                        <div class="SCRPT-info-hdng-col SCRPT-info-title">Target Exam:</div>
                        <div class="SCRPT-info-title"><b>{{selectedTestData?.exam}}</b></div>
                    </li>
                    <li>
                        <div *ngIf="!selectedTestData?.isoffline" class="SCRPT-info-hdng-col SCRPT-info-title">Date:</div>
                        <div *ngIf="!selectedTestData?.isoffline" class="SCRPT-info-title"><b>{{testData?.examsubmitDate | date:'dd MMM, YYYY'}}</b></div>
                    </li>
                    <li>
                        <div *ngIf="!selectedTestData?.isoffline" class="SCRPT-info-hdng-col SCRPT-info-title">Time:</div>
                        <div *ngIf="!selectedTestData?.isoffline" class="SCRPT-info-title"><b>{{(selectedTestData?.isoffline ? selectedTestData?.span : selectedTestData?.examstartedon) | date:'h:mm a'}} <span *ngIf="selectedTestData?.examstartedon || selectedTestData?.span">to</span> {{selectedTestData?.examSubmittedTime | date:'hh : mm a'}}</b></div>
                    </li>
                </ul>
            </div>
        </div>

        
        <div class="SCRPT-score-prgrss-area">
            <div class="SCRPT-sctn-hdng-area">
                <h4 class="SCRPT-sctn-hdng sm-hdng">SCORE Test Report</h4>
            </div>
            <!-- <div class="SCRPT-sctn-hdng-area">
                <h4 class="SCRPT-sctn-hdng">SCORE Test Report</h4>
                <button *ngIf="testUtility.showdownloadReport" (click)="downloadReport()" class="SCRPT-download-btn">Download Report</button>
            </div> -->
            <div class="SCRPT-score-box">
                <div class="SCRPT-score-hdng-area">
                    <div class="score-txt">Your Score</div><div class="score-prize"><b>{{testData?.totalScore}}</b>
                        /{{testData?.outOfScore}}</div>
                </div>
                <div class="scr-sldr-area">
                    <div class="new-custom-progress-bar">
                        <div class="new-your-score-bar" [style.width]="
                        (( testData?.totalScore /testData?.outOfScore)*100) + '%'"></div>
                        <div class="new-avg-score-bar" [ngClass]="{'left-align': (testData?.averageScore / (testData?.outOfScore)) * 100 <= 30 }" [style.width]="(testData?.averageScore / (testData?.outOfScore)) * 100 + '%'">
                            <div class="new-y-score">
                                <span class="new-text">Average Score ({{testData?.averageScore | number : '1.2-2'}})</span>
                            </div>
                        </div>
                        <!-- <div class="new-cutoff-score-bar" style="width: 70%;">
                            <span class="new-score">
                                <span class="new-score-trgt-txt">NEET 2018 Cutoff (600)</span>
                                <img src="assets/img/target-red-icon.svg"
                                    class="trgt-icon" /></span>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>


        <div class="SCRPT-statbx-lstarea">
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <div class="SCRPT-statbx-bx">
                        <div class="SCRPT-statbx-icon-info">
                            <img src="assets/img/goal-lg-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng">Total Time Taken</h3>
                                <h4 class="SCRPT-cunt SCRPT-elips">{{testData?.totaltimespentinhrs}}</h4>
                            </div>
                        </div>
                        <div class="SCRPT-statbx-icon-info" *ngIf="!selectedTestData?.isoffline">
                            <img src="assets/img/best-chapter-yellow-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng score-red-text">Rank will be visible <br> after SCORE Round 1</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div class="SCRPT-main-info-box">
            <div class="SCRPT-sctn-hdng-area">
                <h4 class="SCRPT-sctn-hdng sm-hdng">Overall Stats</h4>
            </div>
            <div class="SCRPT-four-status-box-area">
                <div class="SCRPT-statbx-bx SCRPT-score-statbx">
                    <div class="SCRPT-statbx">
                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                src="assets/img/accuracy-yellow-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng">Accuracy <div
                                        class="SCRPT-c-tooltip"><img src="assets/img/tooltip-info-icon.svg">
                                        <div class="SCRPT-c-tooltip-box accuracy">
                                            <div class="SCRPT-acurcy-toltip-innr">
                                                <div class="SCRPT-acry-txt">Accuracy = </div>
                                                <div>
                                                    <div class="SCRPT-acry-txt">No. of correct answers</div>
                                                    <hr>
                                                    <div class="SCRPT-acry-txt">No. of attempted questions</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </h3>
                                <h4 class="SCRPT-cunt">{{testData?.accuracy}}%</h4>
                            </div>
                        </div>
                    </div>
                    <div class="SCRPT-statbx">
                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                src="assets/img/yellow-clock-md-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng">Avg. time per question</h3>
                                <h4 class="SCRPT-cunt">  {{getSecondsinHours(testData?.averageTimePerQuestion)}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="SCRPT-statbx">
                        <div class="SCRPT-statbx-icon-info"><img
                                src="assets/img/best-chapter-yellow-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng">Best Subjects</h3>
                                <h4 class="SCRPT-cunt SCRPT-elips">{{testData?.bestSubject}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="SCRPT-statbx">
                        <div class="SCRPT-statbx-icon-info"><img
                                src="assets/img/emoji-sad-yellow-icon.svg" alt="">
                            <div>
                                <h3 class="SCRPT-icnhdng">Scope of improvement</h3>
                                <h4 class="SCRPT-cunt">{{testData?.scopeOfImprovement}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- <div class="SCRPT-chart-area">
                <div class="SCRPT-chart-area-row">
                    <div class="SCRPT-chart-area-col">
                        <div class="SCRPT-score-whitetbx">
                            <h3 class="scrbx-hdng">Subjectwise Score</h3>
                            <div class="SCRPT-chart-area-Subjectwise-Score-row">
                                <div class="SCRPT-chart-area-Subjectwise-Score" *ngFor="let subject of testData?.testSubjects">
                                    <div class="SCRPT-scr-chrtbx" >
                                        <div class="SCRPT-scr-chrtarea">
                                            <app-doughnutchart   [colors]="['#FFAD7A', '#e5e9ec']" [labels]="['TotalScore','OutOfScore']" [data]="[(subject?.totalScore<0)?0:subject?.totalScore,(subject?.outOfScore<0)?0:subject?.outOfScore]" ></app-doughnutchart>
                                        </div>
                                        <div class="SCRPT-scr-infobx">
                                            <h2 class="scr-info-titl"> {{subject?.subjectName}}</h2>
                                            <div class="scr-info-cunt">
                                                {{subject?.totalScore}}<span class="scr-light-txt">/{{subject?.outOfScore}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="SCRPT-chart-area-col">
                        <div class="SCRPT-score-whitetbx crt-incrt-chrtbx">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="SCRPT-chrtarea">
                                        <app-doughnutchart   [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="testData?.overallChartData?.labels" [data]="testData?.overallChartData?.data"></app-doughnutchart>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <ul class="chrt-infolist">
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span class="crt-dot green"></span>Correct</h2>
                                                <div class="scr-info-cunt">
                                                    {{testData?.correctAnswer}}<span class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span class="crt-dot red"></span>Incorrect</h2>
                                                <div class="scr-info-cunt">{{testData?.attemptedQuestions}}<span
                                                        class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span class="crt-dot"></span>Not-attempted</h2>
                                                <div class="scr-info-cunt">{{testData?.unAttemptedQuestions}}<span
                                                        class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>




        <div class="SCRPT-sctn-hdng-area">
            <h4 class="SCRPT-sctn-hdng sm-hdng">Subjectwise Score</h4>
        </div>
        <div class="rflex">
            <div class="SCRPT-score-whitetbx">
                <div class="SCRPT-chart-area-Subjectwise-Score-row">
                    <div class="SCRPT-chart-area-Subjectwise-Score" *ngFor="let subject of testData?.testSubjects">
                        <div class="SCRPT-scr-chrtbx" >
                            <div class="SCRPT-scr-chrtarea">
                                <app-doughnutchart   [colors]="['#FFAD7A', '#e5e9ec']" [labels]="['TotalScore','OutOfScore']" [data]="[(subject?.totalScore<0)?0:subject?.totalScore,(subject?.outOfScore<0)?0:subject?.outOfScore]" ></app-doughnutchart>
                            </div>
                            <div class="SCRPT-scr-infobx">
                                <h2 class="scr-info-titl"> {{subject?.subjectName}}</h2>
                                <div class="scr-info-cunt">
                                    {{subject?.totalScore}}<span class="scr-light-txt">/{{subject?.outOfScore}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="SCRPT-score-whitetbx crt-incrt-chrtbx">
                <div class="row">
                    <div class="col-md-5">
                        <div class="SCRPT-chrtarea">
                            <app-doughnutchart   [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="testData?.overallChartData?.labels" [data]="testData?.overallChartData?.data"></app-doughnutchart>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <ul class="chrt-infolist">
                            <li>
                                <div class="SCRPT-scr-infobx lstview">
                                    <h2 class="scr-info-titl"><span class="crt-dot green"></span>Correct</h2>
                                    <div class="scr-info-cunt">
                                        {{testData?.correctAnswer}}<span class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="SCRPT-scr-infobx lstview">
                                    <h2 class="scr-info-titl"><span class="crt-dot red"></span>Incorrect</h2>
                                    <div class="scr-info-cunt">{{testData?.attemptedQuestions}}<span
                                            class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="SCRPT-scr-infobx lstview">
                                    <h2 class="scr-info-titl"><span class="crt-dot"></span>Not-attempted</h2>
                                    <div class="scr-info-cunt">{{testData?.unAttemptedQuestions}}<span
                                            class="scr-light-txt">/{{testData?.totalQuestions}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- page 1 closed -->

<!-- page 2 open -->
<div class="SCRPT-page-wrap pagetwo_show">
    <div class="SCRPT-body-area SCRPT-MT3">  
        <div class="SCRPT-main-info-box">
            <div class="SCRPT-sctn-hdng-area">
                <h4 class="SCRPT-sctn-hdng sm-hdng">Subject-wise breakdown</h4>
            </div>
        </div>
        <ng-container *ngFor="let attemptedsubject of testData?.testSubjects;let i = index">

                <div class="SCRPT-full-subject-info-wrap {{testData?.testSubjects?.length > 3 ? 'SCRPT-MT3' : 'SCRPT-MT'}} {{attemptedsubject?.sectionKeys?.length > 0 ? getPageHight(i) : ''}}" [ngClass]="{'margin-top': i == 3}" >
                <div class="SCRPT-main-info-box subject-hdng-box">
                    <div class="SCRPT-sctn-hdng-area">
                        <h4 class="SCRPT-sctn-hdng sm-hdng iconic"><img src="assets/img/subject-icons/{{attemptedsubject?.subjectName?.replace(' ','') | lowercase }}-icon.svg" class="icn" /><span>{{attemptedsubject?.subjectName}}</span></h4>
                    </div>
                </div>

                <div class="SCRPT-subjct-wsh-sctn">
                    <div class="SCRPT-sctn-hdng-area">
                        <h4 class="SCRPT-sctn-hdng xs-hdng">ALL Sections</h4>
                    </div>
                    <div class="SCRPT-subjct-wsh-area">
                        <div class="SCRPT-score-whitetbx time-lstbox">
                            <div class="SCRPT-scrtmr-lstbx">
                                <div class="SCRPT-scrtmr-col">
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-clock-md-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Total Time taken </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{getSecondsinHours(attemptedsubject?.totalVisitedTime)}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/accuracy-yellow-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Accuracy </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{attemptedsubject?.accuracy}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="SCRPT-scrtmr-col">
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-clock-md-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng">Avg. time per question</h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{getSecondsinHours(attemptedsubject?.avgTimePerQuestion )||'N/A'}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-score-percentage-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Score </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{attemptedsubject?.totalScore}}/{{attemptedsubject?.outOfScore}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SCRPT-score-whitetbx crt-incrt-chrtbx smview">
                            <div class="row">
                                <div class="col-md-4 col-4">
                                    <div class="SCRPT-chrtarea">
                                        <app-doughnutchart   [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="attemptedsubject?.chartData?.labels" [data]="[
                                        attemptedsubject?.totalCorrectQuestions, attemptedsubject?.totalInCorrectQuestions,attemptedsubject?.totalUnAttemptedQuestions
                                        ]"></app-doughnutchart>
                                    </div>
                                </div>
                                <div class="col-md-8 col-8">
                                    <ul class="chrt-infolist">
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot green"></span>Correct</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.totalCorrectQuestions}}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.totalQuestions}}</span></div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot red"></span>Incorrect</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.totalInCorrectQuestions}}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.totalQuestions}}</span></div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot"></span>Not-attempted</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.totalUnAttemptedQuestions}}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.totalQuestions}}</span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        <ng-container *ngFor="let attemptedSections of attemptedsubject?.sectionKeys;let sectionindex = index">
        <div class="SCRPT-subjct-wsh-sctn">
                    <div class="SCRPT-sctn-hdng-area">
                        <h4 class="SCRPT-sctn-hdng xs-hdng">Section {{attemptedSections}}</h4>
                        
                    </div>
                    <div class="SCRPT-subjct-wsh-area">
                        <div class="SCRPT-score-whitetbx time-lstbox">
                            <div class="SCRPT-scrtmr-lstbx">
                                <div class="SCRPT-scrtmr-col">
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-clock-md-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Total Time taken </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{getSecondsinHours(attemptedsubject?.sections[sectionindex][attemptedSections]?.totalVisitedTime)}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/accuracy-yellow-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Accuracy </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{attemptedsubject?.sections[sectionindex][attemptedSections]?.accuracy}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="SCRPT-scrtmr-col">
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-clock-md-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng">Avg. time per question</h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{attemptedsubject?.sections[sectionindex][attemptedSections]?.avgTimePerQuestion ||'N/A'}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="SCRPT-scrtmr-blck">
                                        <div class="SCRPT-statbx-icon-info mob-vew"><img
                                                src="assets/img/yellow-score-percentage-icon.svg" alt="">
                                            <div>
                                                <h3 class="SCRPT-icnhdng"> Score </h3>
                                                <h4 class="SCRPT-cunt SCRPT-elips">{{attemptedsubject?.sections[sectionindex][attemptedSections]?.totalScore}}/{{attemptedsubject?.sections[sectionindex][attemptedSections]?.outOfScore}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="SCRPT-score-whitetbx crt-incrt-chrtbx smview">
                            <div class="row">
                                <div class="col-md-4 col-4">
                                    <div class="SCRPT-chrtarea">
                                        <app-doughnutchart   [colors]="['#6CD5B1', '#ff8c8c', '#e5e9ec']" [labels]="['Correct','In-Correct','Not-Attempted']"
                                        [data]="[ attemptedsubject?.sections[sectionindex][attemptedSections]?.totalCorrectQuestions < 0 ? 0 : attemptedsubject?.sections[sectionindex][attemptedSections]?.totalCorrectQuestions , attemptedsubject?.sections[sectionindex][attemptedSections]?.totalInCorrectQuestions < 0 ? 0 : attemptedsubject?.sections[sectionindex][attemptedSections]?.totalInCorrectQuestions , attemptedsubject?.sections[sectionindex][attemptedSections]?.totalUnAttemptedQuestions < 0 ? 0 : attemptedsubject?.sections[sectionindex][attemptedSections]?.totalUnAttemptedQuestions]"></app-doughnutchart>
                                    </div>
                                </div>
                                <div class="col-md-8 col-8">
                                    <ul class="chrt-infolist">
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot green"></span>Correct</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.sections[sectionindex][attemptedSections]?.totalCorrectQuestions }}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.sections[sectionindex][attemptedSections]?.outOfScore}}</span></div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot red"></span>Incorrect</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.sections[sectionindex][attemptedSections]?.totalInCorrectQuestions}}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.sections[sectionindex][attemptedSections]?.outOfScore}}</span></div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="SCRPT-scr-infobx lstview">
                                                <h2 class="scr-info-titl"><span
                                                        class="crt-dot"></span>Not-attempted</h2>
                                                <div class="scr-info-cunt"> {{attemptedsubject?.sections[sectionindex][attemptedSections]?.totalUnAttemptedQuestions}}<span
                                                        class="scr-light-txt">/{{attemptedsubject?.sections[sectionindex][attemptedSections]?.outOfScore}}</span></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </ng-container>
                </div>
        </ng-container>
    </div>

</div>
<!-- page 2 closed -->





<!-- footer start -->
<div class="SCRPT-page-wrap">
    <div class="SCRPT-footer">
        <div class="col-12">
            <div class="row justify-content-between align-center">
                <div class="col-auto">
                    <a><img src="assets/img/learn-white-logo.svg" class="SCRPT-logo" /></a>
                </div>
                <div class="col-auto">
                    <div class="row">
                        <div class="col-auto">
                            <ul class="SCRPT-footer-infolist address">
                                <li>
                                    <img src="assets/img/map-white-icon.svg" class="icn" />
                                    <span>6th Floor, NCC Building, Durgamma Cheruvu Road, Vittal Rao Nagar, HITEC City, Hyderabad,
                                        Telangana 500081.</span>
                                </li>
                            </ul>
                        </div>
                        <div class="col-auto">
                            <ul class="SCRPT-footer-infolist">
                                <li>
                                    <img src="assets/img/mail-white-icon.svg" class="icn" />
                                    <span>info@infinitylearn.com</span>
                                </li>
                                <li>
                                    <img src="assets/img/phone-white-icon.svg" class="icn" />
                                    <span>+91 9999999999</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>
<!-- footer ended -->
</div>